import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast, TOAST_ERROR, TOAST_SUCCESS, FIVE_SECONDS, TEN_SECONDS } from 'lib/utils';
import { makeRemoteDeleteQueueRequestComment } from 'main/factories/usecases/queue/remote-delete-queue-request-comment';
import { AskRequestStatus } from '@hone-automation/common';
import { invalidateQueueRequestsForLocation } from './queueQueryKeys';

const deleteQueueComment = async (id: string) => {
  const service = makeRemoteDeleteQueueRequestComment(id);
  return service.delete();
};

export const useDeleteQueueCommentMutation = (
  status: AskRequestStatus,
  locationId: string,
  onSuccessCallback?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteQueueComment,
    onSuccess: () => {
      // Invalidate old query key format (used by useQueueRequestsQuery)
      queryClient.invalidateQueries({ queryKey: ['queueRequests', status, locationId] });
      // Invalidate new query key format (used by useGetQueueRequestsQuery in QueueContext)
      invalidateQueueRequestsForLocation(queryClient, locationId);
      queryClient.invalidateQueries({ queryKey: ['queueRequestsCount', locationId] });
      queryClient.invalidateQueries({ queryKey: ['flaggedTransactions', locationId] });
      showToast('Comment deleted', TOAST_SUCCESS, FIVE_SECONDS);
      if (onSuccessCallback) onSuccessCallback();
    },
    onError: (error: any) => {
      showToast(error.message || 'Error while deleting comment', TOAST_ERROR, TEN_SECONDS);
    },
  });
};
